<app-overlay></app-overlay>
<p-toast></p-toast>
<p-toast key="progress-notifications"></p-toast>
<app-main-header *ngIf="(authService.isLoggedIn | async) && !hideNavbar"></app-main-header>
<!-- main app container -->

<router-outlet></router-outlet>